import { ISubscribePageState, statePropName } from './slice';

interface IAppState {
  // this feature state
  [statePropName]: ISubscribePageState;
}

const getState = (state: IAppState) => state[statePropName];

// returns true if subscribe page was started
export const isSubscribeStarted = (state: IAppState) => getState(state).started;

export const getProducts = (state: IAppState) => getState(state).products;

export const isDiscounted = (state: IAppState) => getProducts(state).some((product) => !!product.coupon);
